import React from 'react';
import InfoVideo from './InfoVideo';

export const Info_minting = ({}) => {
  return (
    <>
      <InfoVideo
        title="Navigation"
        description="This video demonstrates the features on the TODEM website, 
        including the differences between Web3 Mode and Art Mode, navigating the Tapestry, 
        and how to find Tile traits."
        source="https://www.latentculture.com/tohm/mp4/navigation_explainer.mp4"
        // Note: the info video component is expecting a .png file with the same name as the .mp4 file
      />

      <InfoVideo
        title="Tiles & Classes"
        description="This video explains how pixels are allocated across the Tapestry, exploring
        why the Tiles are different sizes and how the Tile class system works."
        source="https://www.latentculture.com/tohm/mp4/tile_size_class_explainer.mp4"
        // Note: the info video component is expecting a .png file with the same name as the .mp4 file
      />

      <InfoVideo
        title="Art Construction"
        description="This video explores details of TODEM's creation. It explains the
        mechanics of Tile & subtile generation, provides an overview of thematically significant
        frames, and reveals how underlying images were chosen."
        source="https://www.latentculture.com/tohm/mp4/construction_explainer.mp4"
        // Note: the info video component is expecting a .png file with the same name as the .mp4 file
      />

    </>
  );
};

export default Info_minting;
